import Loadable from '@loadable/component'

export const AdvancePaymentCalculatorMap = Loadable(
  /* webpackChunkName: "AdvancePaymentCalculatorMap" */
  /* webpackPrefetch: "true" */
  /* #__LOADABLE__ */
  () => import('./AdvancePaymentCalculatorMap'),
)
